<div class="{{hasConfigDragRubric ? 'min-width-modal modal-content': 'modal-content'}}">
  <div class="modal-header">
    <div>
      <h4 class="modal-title"><i class="fa fa-signature"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-3" [hidden]="!isCloudSignature">
      <button class="btn btn-sm btn-outline-secondary custom-button-contract" type="button"
              (click)="downloadContract()"
              data-toggle="tooltip" data-placement="top" title="{{ 'TITLE.AGREEMENT-DOWNLOAD' | translate }}">
        <span class="fas fa-file-download" aria-hidden="true"></span>
        {{ "BUTTON.DOWNLOAD-AGREEMENT" | translate }}
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div *ngIf="acceptRubricPlacementChecked">
      <app-alert-add-document
        [message]="loadMessageHtml"></app-alert-add-document>
    </div>
    <!-- Señuelos (OBLIGATORIOS) -->
    <input type="text"
           autocomplete="username"
           name="fake-username"
           tabindex="-1"
           aria-hidden="true"
           style="position:absolute; left:-9999px; opacity:0">

    <input type="password"
           autocomplete="current-password"
           name="fake-password"
           tabindex="-1"
           aria-hidden="true"
           style="position:absolute; left:-9999px; opacity:0">

    <form [formGroup]="signatureForm"
          autocomplete="nope"
          autocapitalize="off">
      <div *ngIf="isRemoteSignature">
        <div class="row">
          <div class="col-md-2">
            <label for="username"><b>{{ "LABEL.USER" | translate }}:</b></label>
            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa fa-user"></i>
                </div>
              </div>
              <input class="form-control {{hasConfigDragRubric ? 'form-width': ''}}"
                     id="username"
                     [(ngModel)]="username"
                     (keyup)="search($event)"
                     (change)="onSignboxDataChanged(username)"
                     formControlName="username"
                     placeholder="{{ 'MESSAGE.ENTER-USER' | translate }}..."
                     [class.is-invalid]="isInvalidControl('username')"
                     autocomplete="new-username"
                     list="signboxList">
              <datalist id="signboxList" *ngIf="uanatacasignboxdatas">
                <option *ngFor="let uanatacasignboxdata of this.uanatacasignboxdatas" [ngValue]="uanatacasignboxdata">
                  {{uanatacasignboxdata.user}} - {{uanatacasignboxdata.reason}}
                </option>
              </datalist>
            </div>
            <small *ngIf="isInvalidControl('username')"
                   class="text-danger">
              {{ "MESSAGE.ENTER-USER" | translate }}
            </small>
          </div>
          <div class="col-md-2">
            <label for="password"><b> {{ 'LABEL.PASSWORD' | translate }}:</b></label>
            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
              <input type="text"
                     id="password"
                     class="form-control col-md-12 offset-md-0 {{ hasConfigDragRubric? 'form-width': ''}}  masked-input"
                     placeholder="{{ 'MESSAGE.ENTER-PASSWORD' | translate }}..."
                     formControlName="password"
                     name="secure-password-field"
                     autocomplete="new-password"
                     spellcheck="false"
                     autocapitalize="off"
                     [class.masked-input]="!viewPassword"
                     [class.is-invalid]="isInvalidControl('password')">
              <div class="input-group-append">
                <span class="input-group-text">
                <i
                  class="fa {{viewPassword?'fa-eye':'fa-eye-slash'}}"
                  (click)="toggleFieldTextType(PASSWORD)"
                ></i>
              </span>
              </div>
            </div>
            <div>
              <small *ngIf="isInvalidControl('password')"
                     class="text-danger">
                {{ "MESSAGE.ENTER-PASSWORD" | translate }}
              </small>
            </div>
          </div>
          <div class="col-md-2">
            <label for="pin"><b>Pin:</b></label>
            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
              <!--              [type]="viewPin ? 'text' : 'password'"-->
              <input type="text"
                     id="pin"
                     class="form-control col-md-12 offset-md-0 {{hasConfigDragRubric? 'form-width': ''}} masked-input"
                     placeholder="{{ 'MESSAGE.ENTER-PIN' | translate }}"
                     formControlName="pin"
                     name="secure-pin-field"
                     autocomplete="one-time-code"
                     spellcheck="false"
                     [class.masked-input]="!viewPin"
                     [class.is-invalid]="isInvalidControl('pin')">
              <div class="input-group-append">
                <span class="input-group-text">
                <i
                  class="fa {{viewPin?'fa-eye':'fa-eye-slash'}}"
                  (click)="toggleFieldTextType(PIN)"
                ></i>
              </span>
              </div>
            </div>
            <div>
              <small *ngIf="isInvalidControl('pin')"
                     class="text-danger">
                {{ "MESSAGE.ENTER-PIN" | translate }}
              </small>
            </div>
          </div>
          <div class="col-md-2">
            <label for="country"><b> {{ "LABEL.LOCALIZATION" | translate }}:</b></label>
            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa fa-globe"></i>
                </div>
              </div>
              <select class="form-control {{hasConfigDragRubric? 'form-width': ''}}"
                      id="country"
                      autocomplete="new-country"
                      formControlName="country"
                      [(ngModel)]="countryIdSelected"
                      [class.is-invalid]="isInvalidControl('country')">
                <option *ngFor="let country of countries" [value]="country.id"> {{country.name | translate}} </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <label for="reason"><b>{{ "LABEL.REASON-FOR-SIGNATURE" | translate }}:</b></label>
            <div class="input-group {{hasConfigDragRubric? 'custom-input-group': ''}}">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa fa-text-height" aria-hidden="true"></i>
                </div>
              </div>
              <input type="text"
                     id="reason"
                     class="form-control col-md-12 offset-md-0 {{hasConfigDragRubric? 'form-width': ''}}"
                     placeholder="{{ 'MESSAGE.ENTER-REASON-SIGNATURE' | translate }}"
                     formControlName="reason"
                     autocomplete="no-autocomplete-4"
                     [class.is-invalid]="isInvalidControl('reason')"
                     [(ngModel)]="reasonForSigning">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!isRemoteSignature">
          <div
            class="col-md-2 font-weight-bold custom-div-sign-remote {{hasCertificateDueDate(certificateDueDate)?'':'custom-div-certificate-hidden'}}">
            {{ "LABEL.CERTIFICATE-EXPIRATION" | translate }}:
          </div>
          <div
            class="col font-weight-light custom-button-sign-remote {{isCertificateDueDateCorrect(certificateDueDate)?'custom-div-certificate-ok':'custom-div-certificate-error'}} {{hasCertificateDueDate(certificateDueDate)?'':'custom-div-certificate-hidden'}}">{{certificateDueDate | dateformat}}</div>
        </div>
      </div>
      <div *ngIf="isCloudSignature || haveDocumentIntegrityToGraficSign">
        <div class="row">
          <div class="custom-col-md-3 custom-button-sign-cloud {{hasConfigDragRubric?'form-width':'custom-button'}}">
            <button
              class="btn btn-primary col font-weight-bold {{ hasConfigDragRubric ? 'form-width': 'custom-button'}} "
              type="button" id="btnSendOTP"
              (click)="generateCodeOrOTP()"
              data-toggle="tooltip" data-placement="top"
              title="{{ 'MESSAGE.MAKE-CODE-REQUEST' | translate }}">
              <span class="{{isCloudSignature ? 'fas fa-mobile-alt' : 'fa fa-envelope'}} " aria-hidden="true"></span>
              {{ "BUTTON.REQUEST-CODE" | translate }}
            </button>
          </div>
          <div class="col-md-2 custom-button-sign-cloud">
            <input type="text"
                   id="codeOTP"
                   class="form-control col-md-12 {{hasConfigDragRubric? 'form-width': ''}}"
                   placeholder="{{ 'MESSAGE.ENTER-CODE' | translate }}..."
                   formControlName="codeOTP"
                   [class.is-invalid]="isInvalidControl('codeOTP')"
                   [(ngModel)]="codeOTP"
                   [maxLength]="6">
            <small *ngIf="isInvalidControl('codeOTP')"
                   class="text-danger">
              {{ "MESSAGE.ENTER-CODE-6-DIGIT" | translate }}
            </small>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div *ngIf="!acceptRubricPlacementChecked">
          <div class="col-md-2 col-md-2-custom font-weight-bold">{{ "LABEL.ATTACHMENTS" | translate }}</div>
          <div class="col-md-12 offset-md-0 font-weight-light">
            <a href="javascript:" *ngFor="let resource1 of resources; let index=index"
               class="{{this.resource === resource1 ? 'font-weight-bold' : ''}}"
               (click)="selectAttachment(resource1)">{{resource1.fileName}}; </a>
          </div>
        </div>

        <div class="col-md-3 offset-md-0 font-weight-light" *ngIf="acceptRubricPlacementChecked">
          <div class="font-weight-bold">{{ "LABEL.ATTACHMENTS" | translate }}</div>
          <div class="dropdown">
            <a class="btn btn-light dropdown-toggle min-w-100" role="button"
               data-toggle="dropdown" aria-expanded="false">
              <b class="text-primary">
                <span>{{cutFileName(resource.fileName)}}</span>
              </b>
            </a>

            <div class="dropdown-menu">
              <a class="dropdown-item">
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox"
                         class="custom-control-input"
                         id="addRemoveAllCheckbox1"
                         [checked]="wasAllSelected1()"
                         (click)="addOrRemoveAll($event)">
                  <label class="custom-control-label"
                         for="addRemoveAllCheckbox1"><b>{{ "LABEL.ALL-RUBRIC-POSITION-CONFIRM" | translate}}</b></label>
                </div>
              </a>
              <a *ngFor="let resource1 of resources; let index=index"
                 class="dropdown-item {{wasChecked(resource1) ? 'bg-custom': ''}} cursor-pointer min-w-130 {{resource1 === resource ? 'bg-gray':''}}">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox"
                         id="resourceCheckbox{{index}}"
                         name="groupRadio"
                         class="custom-control-input"
                         [value]="resource1"
                         [checked]="wasSelected2(resource1)"
                         (click)="addRemoveResource($event ,resource1)">
                  <label class="custom-control-label" for="resourceCheckbox{{index}}"></label>
                  <label (click)="selectAttachment(resource1)"
                         class="cursor-pointer">{{ cutFileName(resource1.fileName)}}</label>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!isCloseStampingAndIsNotDigitalSignature && hasConfigRubric">
        <div class="col-md-2 font-weight-bold col-form-label">{{ "LABEL.STAMPING-IMAGE" | translate }}</div>
        <div class="col-md-2 font-weight-light">
          <label for="signaturePad" class="col-form-label w-100">{{ "LABEL.RUBRIC" | translate }}</label>
          <div class="custom-file {{hasConfigDragRubric? 'custom-file-fixed':''}}">
            <button type="button"
                    id="signaturePad"
                    class="btn btn-sm btn-block btn-outline-success {{hasConfigDragRubric? 'form-width': 'custom-button'}}"
                    (click)="signaturePad()">
              <i class="fa fa-sync-alt"></i> {{ "BUTTON.UPDATE" | translate }}
            </button>
          </div>
        </div>
        <div class="col-md-1">
          <label for="signaturePad" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
          <div>
            <img [src]="defaultRubricSrc" style="{{styleDimensionsRubric}}" alt="Rubric">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 col-md-2-custom" *ngIf="haveDocumentIntegrityToGraficSign && needShowImages">
          <label
            class="col-form-label font-weight-bold">{{ "LABEL.IMAGE-OF-THE-IDENTIFICATION-DOCUMENT" | translate }} </label>
        </div>
        <div class="col">
          <div class="row" *ngIf="haveDocumentIntegrityToGraficSign && needShowImages">
            <div class="col-md-9">
              <label for="obverseDNI"
                     class="col-form-label font-weight-bold w-100">{{ "LABEL.FRONT-PART-OF-THE-IDENTIFICATION-DOCUMENT" | translate }}</label>
              <div class="custom-file content-file {{hasConfigDragRubric? 'custom-file-fixed':''}}">
                <input type="file"
                       class="custom-file-input {{hasConfigDragRubric? 'form-width': ''}}"
                       accept="image/jpeg, image/png"
                       alife-file-to-base64
                       id="obverseDNI"
                       (change)="readSelectedDocumentFront($event)"
                       (onFileChanged)="changeStatus3($event)"
                       [class.is-invalid]="isInvalidControl('documentFrontFilename2Show')">
                <small *ngIf="isInvalidControl('documentFrontFilename2Show')"
                       class="text-danger">
                  {{ "MESSAGE.SELECT-IMAGE-OF-FRONT-OF-IDENTITY-DOCUMENT" | translate }}
                </small>
                <div class="custom-file-label">
                  <label for="obverseDNI">
                    {{signatureForm.get('documentFrontFilename2Show').value ? signatureForm.get('documentFrontFilename2Show').value : 'MESSAGE.SELECT' | translate}}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-1 col-md-2-custom">
              <label for="obverseDNI" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
              <div>
                <img [src]="defaultDocumentFrontSrc" #rubricPic style="{{styleDimensionsRubric}}" alt="Rubric">
              </div>
            </div>
          </div>
          <div class="row" *ngIf="haveDocumentIntegrityToGraficSign && needShowImages">
            <div class="col-md-9">
              <label for="backDNI"
                     class="col-form-label font-weight-bold w-100">{{ "LABEL.REVERSE-SIDE-OF-IDENTIFICATION-DOCUMENT" | translate }}</label>
              <div class="custom-file content-file {{hasConfigDragRubric? 'custom-file-fixed':''}}">
                <input type="file"
                       class="custom-file-input {{hasConfigDragRubric? 'form-width': ''}}"
                       accept="image/jpeg, image/png"
                       alife-file-to-base64
                       id="backDNI"
                       (change)="readSelectedBackDNI($event)"
                       (onFileChanged)="changeStatus4($event)"
                       [class.is-invalid]="isInvalidControl('documentRearFilename2Show')">
                <small *ngIf="isInvalidControl('documentRearFilename2Show')"
                       class="text-danger">
                  {{ "MESSAGE.SELECT-IMAGE-OF-BACK-OF-IDENTITY-DOCUMENT" | translate }}
                </small>
                <div class="custom-file-label">
                  <label for="backDNI">
                    {{signatureForm.get('documentRearFilename2Show').value ? signatureForm.get('documentRearFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-1 col-md-2-custom">
              <label for="backDNI" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
              <div>
                <img [src]="defaultDocumentRearSrc" #rubricPic style="{{styleDimensionsRubric}}" alt="Rubric">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row nowrap">
        <div class="col-md-2 offset-md-2 mt-2"
             *ngIf="haveDocumentIntegrityToGraficSign && needShowImages">
          <button type="button"
                  class="btn btn-sm  btn-outline-success font-weight-bold mw-180 {{hasConfigDragRubric? 'form-width': 'custom-button'}}"
                  (click)="updateImages()">
            <i class="fa fa-sync-alt"></i> {{ "BUTTON.UPDATE-IMAGES" | translate }}
          </button>
        </div>
      </div>
      <div class="{{hasConfigDragRubric ? 'pdf-box':'' }} ">
        <app-pdf-viewer *ngIf="!reloadingPdf" [urlStream]="urlStream" [rubricSrc]="defaultRubricSrc"
                        [showRubric]="hasConfigDragRubric && this.resource.sign"
                        [signatureDescriptions]="getListSignatureDescription()"
                        [typeSignature]="typeSignature"
                        [personId]="getPersonId()"
                        [isUser]="true"
                        [resource]="this.resource"
                        [signComplete]="false"
                        [isLastOperator]="false"
                        (rubricDragged)="rubricDragEnd($event)"
                        [eventDragging]="eventsSubject.asObservable()">
        </app-pdf-viewer>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="container">
      <div class="row">
        <div class="col {{hasConfigDragRubric ? 'offset-md-3': 'custom-offset-md-3 flex-end'}} offset-custom"
             *ngIf="isDigitalSignature">
          <button type="button"
                  class="btn btn-outline-primary font-weight-bold {{hasConfigDragRubric ? 'mx-wd': 'mx-wd-mobile custom-button margin-left'}}"
                  (click)="digitalSign()">
            <span class="fa fa-signature" aria-hidden="true"></span>
            {{ "BUTTON.SIGN" | translate }}
          </button>
        </div>
        <div class="col {{hasConfigDragRubric ? 'offset-md-3': 'custom-offset-md-3 flex-end'}}  offset-custom"
             *ngIf="isNotify">
          <button
            class="btn btn-outline-primary font-weight-bold {{hasConfigDragRubric ? 'mx-wd': 'mx-wd-mobile custom-button margin-left'}}"
            type="button"
            (click)="sign()"
            data-toggle="tooltip" data-placement="top" title="{{ 'TITLE.NOTIFY' | translate }}">
            <span class="fas fa-mail-bulk" aria-hidden="true"></span>
            {{ "BUTTON.NOTIFY" | translate }}
          </button>
        </div>
        <div class="col {{hasConfigDragRubric ? 'offset-md-3': 'custom-offset-md-3 flex-end' }}  offset-custom"
             *ngIf="isElectronicSignature">
          <button
            class="btn btn-outline-primary font-weight-bold {{hasConfigDragRubric ? 'mx-wd': 'mx-wd-mobile custom-button margin-left' }}"
            type="button"
            (click)="signGraphic()"
            [disabled]="!haveDocIdentificationImages(person) && haveDocumentIntegrityToGraficSign"
            data-toggle="tooltip" data-placement="top" title="{{ 'TITLE.GRAPHIC-SIGNATURE' | translate }}">
            <span class="fa fa-signature" aria-hidden="true"></span>
            {{ "BUTTON.SIGN" | translate }}
          </button>
        </div>
        <div class="col {{hasConfigDragRubric ? 'offset-md-3': 'custom-offset-md-3 flex-end'}}  offset-custom"
             *ngIf="isCloudSignature">
          <button
            class="btn btn-outline-primary font-weight-bold {{hasConfigDragRubric ? 'mx-wd': 'mx-wd-mobile custom-button margin-left'}}"
            type="button"
            [disabled]="!codeSent"
            (click)="signInCloud()" style="min-width: 152px !important;"
            data-toggle="tooltip" data-placement="top" title="{{ 'TITLE.SIGN-ONE-SIGN' | translate }}">
            <span class="fa fa-signature" aria-hidden="true"></span>
            {{ "BUTTON.SIGN" | translate }}
          </button>
        </div>
        <div class="col {{hasConfigDragRubric ? 'offset-md-3': 'custom-offset-md-3 flex-end'}}  offset-custom"
             *ngIf="isRemoteSignature">
          <button
            class="btn btn-outline-primary font-weight-bold {{hasConfigDragRubric ? 'mx-wd': 'mx-wd-mobile custom-button margin-left'}}"
            type="button"
            (click)="singBox()"
            data-toggle="tooltip" data-placement="top" title="{{ 'TITLE.REMOTE-SIGNATURE' | translate }}">
            <span class="fa fa-signature" aria-hidden="true"></span>
            {{ "BUTTON.SIGN" | translate }}
          </button>
        </div>
        <div class="col offset-custom flex-end">
          <button type="button"
                  class="btn btn-outline-danger font-weight-bold {{hasConfigDragRubric? 'mx-wd': 'mx-wd-mobile custom-button margin-left mt-1'}}"
                  (click)="cancel()">
            <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading *ngIf="loading || reloadingPerson"></app-loading>
